module.exports = __webpack_public_path__ + "img/symbol_4.4af50925.png";